import React from 'react';

import { observer } from 'mobx-react';

import { LinearStepper, LinearStepOption } from '@infoods/lifebase-ui';
import { useStepper } from '../../../../../shared/hooks/useStepper';
import { ExistAccountStep } from './containers/ExistAccountStep/ExistAccountStep';
import { PersonalInfoStep } from './containers/PersonalInfoStep/PersonalInfoStep';
import { ChooseChallengeStep } from './containers/ChooseChallengeStep/ChooseChallengeStep';
import { challengeSignUpStore } from '../../../../stores/challengeSignUpStore';
import { SETUP_STATUS } from '../../../../../scan-iq-customer-management';

const SignUpInfoStep = observer(() => {
  const { activeStep, goToNextStep } = useStepper();

  const { customer, isLifeBaseWithoutActiveSubscription, getChallengePaymentInfo } =
    challengeSignUpStore;

  const chooseChallengeStepTitles = isLifeBaseWithoutActiveSubscription
    ? {
        title: `We've found your nutrition account, but it's currently inactive`,
        description:
          'Please purchase your challenge ticket and then contact your coach to reactive your nutrition account.',
      }
    : {
        title: 'Pick a challenge to continue',
        description: 'Enter a promo code, if applicable, and proceed to checkout',
      };

  const handleSuccessSubmit = async () => {
    await getChallengePaymentInfo();
    goToNextStep();
  };

  const stepsConfig: LinearStepOption[] = [
    customer?.setupStatus === SETUP_STATUS.COMPLETED
      ? {
          title: `We've found your account. Complete your nickname`,
          description: 'All fields are required',
          step: <ExistAccountStep onSuccessSubmit={handleSuccessSubmit} />,
        }
      : {
          title: 'Please fill out your personal information',
          description: 'All fields are required',
          step: <PersonalInfoStep onSuccessSubmit={handleSuccessSubmit} />,
        },
    {
      title: chooseChallengeStepTitles.title,
      description: chooseChallengeStepTitles.description,
      step: <ChooseChallengeStep />,
    },
  ];

  return (
    <LinearStepper label="User Form" activeStep={activeStep} stepsConfig={stepsConfig} />
  );
});

export { SignUpInfoStep };
